import styled from "styled-components";

export const ActionButton = styled.button`
  background-color: #000;
  color: #fff;
  padding: 8px;
  width: 112px;
  border-width: 0;
  font-family: Oswald;
  font-style: normal;
  font-weight: 500;
  font-size: 16px;
  cursor: pointer;

  :hover {
    opacity: 0.6;
  }
`;
